import React, { createContext, useContext, useState, useEffect } from 'react';
import { configAPI } from '../api';

// Default fallback value
const DEFAULT_SIGNUP_CREDITS = 100;

const SignupConfigContext = createContext({
  signupCredits: DEFAULT_SIGNUP_CREDITS,
  loading: true,
  error: null,
  refetch: () => {}
});

export const SignupConfigProvider = ({ children }) => {
  const [signupCredits, setSignupCredits] = useState(DEFAULT_SIGNUP_CREDITS);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchConfig = async () => {
    try {
      setLoading(true);
      const response = await configAPI.getSignupConfig();
      if (response.data?.signup_credits) {
        setSignupCredits(response.data.signup_credits);
      }
      setError(null);
    } catch (err) {
      console.warn('Failed to fetch signup config, using default:', err);
      setError(err);
      // Keep default value on error
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchConfig();
  }, []);

  return (
    <SignupConfigContext.Provider value={{ 
      signupCredits, 
      loading, 
      error, 
      refetch: fetchConfig 
    }}>
      {children}
    </SignupConfigContext.Provider>
  );
};

export const useSignupConfig = () => {
  const context = useContext(SignupConfigContext);
  if (!context) {
    throw new Error('useSignupConfig must be used within SignupConfigProvider');
  }
  return context;
};

export default SignupConfigContext;
